<template>
  <div class="tenant_info_area" id="tenant_info">
    <div class="edit_area_half">
      <inputCannotChangedSection
        :titleLabel="companyIdLabel"
        @inputUpdate="inputAddUpdate('companyId')"
      ></inputCannotChangedSection>
      <inputSection
        :titleLabel="companyNameLabel"
        @inputUpdate="inputAddUpdate('companyName')"
      ></inputSection>
      <checkBoxBindSection
        :titleLabel="LocationInfoEnableFlagLabel"
        :nameValue="locationInfoEnableFlag"
        :checked="false"
        @inputUpdate="inputAddUpdate('locationInfoEnableFlag')"
      ></checkBoxBindSection>
      <checkBoxSection
        :titleLabel="mailTargetFlagLabel"
        :nameValue="mailTargetFlag"
        @inputUpdate="inputAddUpdate('mailTargetFlag')"
      ></checkBoxSection>
    </div>
    <div class="edit_area_half">
      <inputSection
        :titleLabel="adminUserIdLabel"
        @inputUpdate="inputAddUpdateAdminUser('adminUserId')"
      ></inputSection>
      <inputSection
        :titleLabel="adminUserNameLabel"
        @inputUpdate="inputAddUpdateAdminUser('adminUserName')"
      ></inputSection>
      <inputSection
        :titleLabel="mailAddressLabel"
        @inputUpdate="inputAddUpdateAdminUser('mailAddress')"
      ></inputSection>
      <inputSection
        :titleLabel="passwordLabel"
        @inputUpdate="inputAddUpdateAdminUser('password')"
      ></inputSection>
    </div>
  </div>
</template>

<script>
import inputSection from './inputSection.vue'
import checkBoxSection from './checkBoxSection.vue'
import inputCannotChangedSection from './inputCannotChangedSection.vue'
import checkBoxBindSection from './checkBoxBindSection.vue'

export default {
  data() {
    return {
      companyIdLabel: 'テナントID',
      companyNameLabel: 'テナント名',
      LocationInfoEnableFlagLabel: 'ビーコン情報機能の使用有無',
      GpsEnableFlagLabel: 'GPS情報機能の使用有無',
      adminUserIdLabel: '管理者ID',
      adminUserNameLabel: '管理者名',
      mailAddressLabel: 'メールアドレス',
      passwordLabel: '管理者パスワード',
      locationInfoEnableFlag: 'location_info_enable',
      gpsEnableFlag: 'gps_enable',
      mailTargetFlagLabel: '警告メール送信の使用有無',
      mailTargetFlag: 'mail_target'
    }
  },
  components: {
    inputSection,
    checkBoxSection,
    inputCannotChangedSection,
    checkBoxBindSection
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('corporations/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    inputAddUpdateAdminUser(e) {
      this.$store.dispatch('corporations/inputAddUpdateAdminUser', {
        name: e,
        value: event.target.value
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/tenantAddInfo.vue